import { useState, useEffect } from 'react';
import { getUserFinancialStatement } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';
import { getTodayDateRange } from '../../Utils/dateFormatter';

export default function useFinancialStatement(userId, dateFrom = null, dateTo = null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const fetchStatement = async () => {
      setLoading(true);
      setError(null);

      try {
        const defaultDates = getTodayDateRange();

        const params = {
          date_from: dateFrom || defaultDates.dateFrom,
          date_to: dateTo || defaultDates.dateTo
        };

        const response = await getUserFinancialStatement(userId, params);
        setData(response.data);
      } catch (err) {
        const errorMessage = handleApiError(err);
        setError(errorMessage);
        console.error('❌ خطأ في جلب كشف الحساب:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStatement();
  }, [userId, dateFrom, dateTo]);

  return { data, loading, error };
}
